export const deviceMapTypes = {
    UPDATE_REQUEST: "DEVICE_MAP_UPDATE_REQUEST",
    HANDLE_DEVICE_MAP_PLAY_PAUSE_REQUEST: "HANDLE_DEVICE_MAP_PLAY_PAUSE_REQUEST",
    HANDLE_DEVICE_MAP_PLAY_PAUSE_SUCCESS: "HANDLE_DEVICE_MAP_PLAY_PAUSE_SUCCESS",
    HANDLE_DEVICE_MAP_PLAY_PAUSE_FAILURE: "HANDLE_DEVICE_MAP_PLAY_PAUSE_FAILURE",
    FETCH_DEVICE_MAP_REQUEST: "DEVICE_MAP_FETCH_REQUEST",
    FETCH_DEVICE_MAP_SUCCESS: "DEVICE_MAP_FETCH_SUCCESS",
    FETCH_DEVICE_MAP_FAILURE: "DEVICE_MAP_FETCH_FAILURE",
};

export const updateRequest = (req) => ({
    type: deviceMapTypes.UPDATE_REQUEST,
    payload: req
});

export const handlePlayPauseRequest = (req) => ({
    type: deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_REQUEST,
    payload: req
})

export const handlePlayPauseSuccess = (res) => ({
    type: deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_SUCCESS,
    payload: res
})

export const handlePlayPauseFailure = (res) => ({
    type: deviceMapTypes.HANDLE_DEVICE_MAP_PLAY_PAUSE_FAILURE,
    payload: res
})

export const fetchDeviceMapRequest = (req) => ({
    type: deviceMapTypes.FETCH_DEVICE_MAP_REQUEST,
    payload: req
});

export const fetchDeviceMapSuccess = (resp) => ({
    type: deviceMapTypes.FETCH_DEVICE_MAP_SUCCESS,
    payload: resp
});

export const fetchDeviceMapFailure = (error) => ({
    type: deviceMapTypes.FETCH_DEVICE_MAP_FAILURE,
    payload: error
});